module.exports = __webpack_public_path__ + "static/img/19090D_1_C_20240319_LC.8d96421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19090D_1_C_20240319_LC.png
// module id = SmoZ
// module chunks = 0